module.exports = __webpack_public_path__ + "media/images/static_page/fliist_short_logo2x-84d1e401797a10082f74d76bd9b03dde.png";